import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useAsyncFn } from 'react-use';
import { bindActionCreators } from 'redux';

import { abeCashupAllCombinedRead } from 'actions/cashup/beCashup.action';
import beCashupAndReconcile from 'actions/cashup/beCashupAndReconcile.action';
import { abeCashupVouchersRead } from 'actions/cashup/beCashupVoucher.action';
import { fromAnyDateToZulu } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';

import Cashup from 'cashup/Cashup.component';

const L = logger('CashupAll');

const CashupAll = (props) => {
  const { abeCashupVouchersRead, beCashupAndReconcile } = props ?? {};

  const [{ error: errorCashup }, handleCashup] = useAsyncFn(
    async (ev) => {
      const options = { ...ev, beCashup: abeCashupAllCombinedRead };
      const result = await beCashupAndReconcile(options);
      L.debug('handleCashup()', result, '<-', options, '<-', ev);
    },
    [beCashupAndReconcile],
  );

  const [{ error: errorVouchers }, handleVouchers] = useAsyncFn(
    async (...args) => {
      const [ev, bgn, end] = args; // to make it more readable

      const options = {
        bgn: ev?.bgn ?? bgn,
        end: ev?.end ?? end,
        filter: true,
      };

      const result = await abeCashupVouchersRead(options);
      const json = result?.json;

      const bgnZulu = fromAnyDateToZulu(bgn);
      const endZulu = fromAnyDateToZulu(end);

      L.debug('handleVouchers()', { bgnZulu, endZulu, json, result, args, options });
    },
    [abeCashupVouchersRead],
  );

  useEffect(() => void L.unignore('()', 'handleVouchers:', handleVouchers()), [handleVouchers]);

  const error = errorVouchers || errorCashup;
  if (error) L.warn('()', error);

  return <Cashup {...props} beCashupAndReconcile={handleCashup} fetchVouchersSold={handleVouchers} permission="all" />;
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      beCashupAndReconcile,
      abeCashupVouchersRead,
    },
    dispatch,
  );

const CashupAllHoc = connect(null, mapDispatchToProps)(CashupAll);

export default CashupAllHoc;
